import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserRegistration } from "@/components/UserRegistration";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { HeroVideoSection } from "@/components/HeroVideoSection";
import { GlobalMetricsSection } from "@/components/GlobalMetricsSection";
import { AboutFutWorkSection } from "@/components/AboutFutWorkSection";
import { HowWeDoItSection } from "@/components/HowWeDoItSection";

import { FutWorkCTA } from "@/components/FutWorkCTA";

const Index = () => {
  const navigate = useNavigate();
  const [isRedirecting, setIsRedirecting] = useState(false);

  useEffect(() => {
    // Check if user is registered (localStorage-based system)
    const savedUser = localStorage.getItem('soccer-registered-user');
    if (savedUser) {
      try {
        const parsedUser = JSON.parse(savedUser);
        // Check if user has required fields for new secure system
        if (parsedUser.playerId && parsedUser.jerseyNumber) {
          console.log('Registered user found, redirecting to player dashboard');
          setIsRedirecting(true);
          navigate('/player', { replace: true });
          return;
        }
      } catch {
        // Invalid JSON - clear and stay on login
        localStorage.removeItem('soccer-registered-user');
      }
    }
  }, [navigate]);

  // Always show loading/redirect for logged in users
  if (isRedirecting) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-emerald-900 to-blue-900 flex items-center justify-center">
        <div className="text-white text-xl">Redirecting to dashboard...</div>
      </div>
    );
  }

  const handleRegistrationComplete = (userData: any) => {
    console.log('Registration completed, redirecting to player dashboard');
    localStorage.setItem('soccer-registered-user', JSON.stringify(userData));
    navigate('/player', { replace: true });
  };

  // Show landing page for non-registered users
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      {/* Hero Video Section */}
      <HeroVideoSection />
      
      {/* About FutWork.io Section */}
      <AboutFutWorkSection />
      
      {/* How We Do It Section */}
      <HowWeDoItSection />
      
      {/* Global Metrics Section */}
      <GlobalMetricsSection />
      
      
      {/* FutWork CTA Section */}
      <section className="py-8 bg-background">
        <div className="container mx-auto px-4 max-w-4xl">
          <FutWorkCTA />
        </div>
      </section>
      
      {/* Sign In Section */}
      <div 
        id="sign-in"
        className="bg-cover bg-center bg-no-repeat relative flex items-center justify-center p-8 md:p-16"
        style={{ backgroundImage: 'url(/lovable-uploads/2b07ff73-c5d3-403f-a2c8-a944f208de6b.png)' }}
      >
        {/* FutWork brand gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-br from-[#0248c1]/90 via-[#111835]/80 to-[#0248c1]/95" />
        
        <div className="w-full max-w-md relative z-10">
          <UserRegistration onRegistrationComplete={handleRegistrationComplete} />
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default Index;
